<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="商品名" label-width="80px">
        <el-input v-model="searchForm.name" clearable placeholder="商品名">
        </el-input>
      </el-form-item>
      <el-form-item label="商品类型" label-width="80px">
        <el-cascader
          ref="cateData"
          v-model="classifyId"
          :options="typeList"
          :props="{
            checkStrictly: true,
            value: 'id',
            label: 'name',
            children: 'children',
          }"
          clearable
          filterable
          placeholder="选择分类"
          @change="onSelectPMenu"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getod()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-spinner="el-icon-loading"
      element-loading-text="拼命加载中"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        label="商品封面"
        prop="storeGoodsCover"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.cover"
            fit="scale-down"
            style="width: 70px; height: 70px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品名" prop="name" width="260">
      </el-table-column>
      <el-table-column
        align="center"
        label="商品类型"
        prop="classifyName"
        width="148"
      >
      </el-table-column>
      <el-table-column align="center" label="商品分类是否可拼团" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.isGroupBuying == 1">是</div>
          <div v-if="scope.row.isGroupBuying == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品规格"
        min-width="400"
        prop="parameters"
      >
        <template slot-scope="{ row }">
          <div
            v-for="(item, index) in row.commoditSpecificationsList"
            :key="index"
          >
            规格名：{{ item.commoditSpecifications }}； 
            原价：{{ item.originalPrice }} ；
             {{row.sellingPriceName||'售价'}}：{{ item.price }}；
            {{row.storePriceName||'达人价'}}：{{ item.storePrice }}；
            
            
            <span v-if="row.isGroupBuying == 1"
              >拼团价：{{ item.groupBuyingPrice || 0 }}；</span
            ><span v-if="row.isLimitedTimeDiscount == 1"
              >秒杀价：{{ item.limitedTimeDiscountPrice || 0 }}；</span
            >
            <span v-if="row.isGift == 1"
              >库存：{{ item.inventory || 0 }}；</span
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品标签"
        prop="parameters"
        width="300"
      >
        <template slot-scope="{ row }">
          <div v-for="(item, index) in row.productLabelsList" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品销量"
        prop="salesVolume"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        label="是否为赠品"
        prop="isGift"
        width="140"
      >
        <template slot-scope="{ row }">
          {{ row.isGift == 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="排序"
        prop="sort"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="240"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:send:xiajia')"
            slot="reference"
            plain
            type="success"
            @click="updStoreGoodsIsOnframe(scope.row)"
          >
            下架
          </el-button>
          <el-button
            v-if="hasAuth('sys:send:detail')"
            plain
            type="primary"
            @click="lookinfo(scope.row)"
            >查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :visible.sync="smvisible"
      append-to-body
      class="dialogClass"
      title="商品详情"
      width="80%"
    >
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品名称:</div>
        <div class="">
          {{ shopinfo.name }}
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品分类:</div>
        <div class="">
          {{ shopinfo.firstClassifyName }} —— {{ shopinfo.classifyName }}
        </div>
      </div>

      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">是否可拼团:</div>
        <div class="">
          {{ shopinfo.isGroupBuying == 1 ? "是" : "否" }}
        </div>
      </div>
      <div
        class="flexcen"
        style="margin-bottom: 20px"
        v-if="shopinfo.isGroupBuying == 1"
      >
        <div class="titcon">拼团人数:</div>
        <div class="">
          {{ shopinfo.groupBuyingNum }}
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">是否是限时秒杀:</div>
        <div class="">
          {{ shopinfo.isLimitedTimeDiscount == 1 ? "是" : "否" }}
        </div>
      </div>
      <div
        class="flexcen"
        style="margin-bottom: 20px"
        v-if="shopinfo.isLimitedTimeDiscount == 1"
      >
        <div class="titcon">限时秒杀人数:</div>
        <div class="">
          {{ shopinfo.limitedTimeDiscountNum }}
        </div>
      </div>
      <div
        class="flexcen"
        style="margin-bottom: 20px"
        v-if="shopinfo.isLimitedTimeDiscount == 1"
      >
        <div class="titcon">限时秒杀时效:</div>
        <div class="">
          {{ shopinfo.limitedTimeDiscountEndTime }}
        </div>
      </div>
      <div
        class="flexcen"
        style="margin-bottom: 20px"
        v-if="shopinfo.isLimitedTimeDiscount == 1"
      >
        <div class="titcon">限时秒杀件数:</div>
        <div class="">
          {{ shopinfo.limitedTimeDiscountCommodityNum }}
        </div>
      </div>

      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">是否为赠品:</div>
        <div class="">
          {{ shopinfo.isGift == 1 ? "是" : "否" }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品规格:</div>
        <div class="">
          <div 
            v-for="(item, index) in shopinfo.commoditSpecificationsList"
            :key="index"
          >
            <el-divider content-position="left">规格{{ index + 1 }}</el-divider>
            <el-row :gutter="20">
              <el-col :span="24" style="margin-bottom: 20px">规格名：{{
                item.commoditSpecifications
              }}</el-col>
              <el-col :span="6" style="margin-bottom: 20px"
                >原价：{{ item.originalPrice }}</el-col
              >
              <el-col :span="6" style="margin-bottom: 20px"
                >{{ item.sellingPriceName || "售价" }}：{{ item.price }}</el-col
              >
              <el-col :span="6" style="margin-bottom: 20px"
                >{{ item.storePriceName || "达人价" }}：{{
                  item.storePrice
                }}</el-col
              >
              <el-col :span="6" style="margin-bottom: 20px" v-if="shopinfo.isGift == 1"
                >库存：{{ item.inventory }}</el-col
              >
              <el-col :span="6" style="margin-bottom: 20px" v-if="shopinfo.isGroupBuying == 1"
                >拼团价：{{ item.groupBuyingPrice }}</el-col
              >
              <el-col :span="6" style="margin-bottom: 20px" v-if="shopinfo.isLimitedTimeDiscount == 1"
                >秒杀价：{{ item.limitedTimeDiscountPrice }}</el-col
              >
            </el-row>
          </div>
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品标签:</div>
        <div
          v-for="(item, index) in shopinfo.productLabelsList"
          :key="index"
          class=""
        >
          {{ item || "" }} /
        </div>
      </div>

      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品参数:</div>
        <div class="">
          {{ shopinfo.parameters }}
        </div>
      </div>

      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品说明:</div>
        <div class="">
          {{ shopinfo.explain }}
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">封面:</div>
        <div class="">
          <img :src="shopinfo.cover" alt="" class="stimg" />
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品轮播:</div>
        <div class="">
          <img
            v-for="(item, index) in shopinfo.imgList"
            :key="index"
            :src="item"
            alt=""
            class="stimg"
          />
        </div>
      </div>
      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">三证信息:</div>
        <div class="cont" v-html="shopinfo.threeCertificateInformation"></div>
      </div>

      <div class="flexcen" style="margin-bottom: 20px">
        <div class="titcon">商品详情:</div>
        <div class="cont" v-html="shopinfo.imgDetail"></div>
      </div>
    </el-dialog>
    <Sing
      v-if="dialog"
      ref="addUpdateSingProduct"
      @refreshDataList="getStoreGoods"
    ></Sing>
    <BalancePayment
      v-if="balancePaymentVisble"
      ref="balancePayment"
      @refreshDataList="getStoreGoods"
    >
    </BalancePayment>
    <AddParameter
      v-if="getParametervisible"
      ref="getParameter"
      @refreshDataList="getStoreGoods"
    ></AddParameter>
  </div>
</template>

<script>
import Sing from "./components/SingProduct";
import BalancePayment from "./BalancePayment";

import AddParameter from "./AddParameter";

export default {
  name: "SingProduct",
  components: {
    Sing,
    BalancePayment,
    AddParameter,
  },
  data() {
    return {
      smvisible: false,
      sortVisible: false,
      boxItemsVisible: false,
      nonQueuingVisible: false,
      getParametervisible: false,
      dialog: false,
      gardenNames: "",
      shopinfo: "",
      loading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        storeGoodsType: "",
        supplierName: "",
        classifyFirstId: "",
        name: "",
        type: 0,
      },
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      GardenIdList: [],
      classifyId: [],
      typeList: [],
      total: 0,
      size: 10,
      current: 1,
      addUpdateSingProductVisible: false,
      updateGoodssVisible: false,
      balancePaymentVisble: false,
      ids: [],
      supList: [],
    };
  },
  created() {
    this.getStoreGoods();

    this.getTypeList();
    this.supp();
  },
  methods: {
    onSelectPMenu(val) {
      console.log("777");
    },
    supp() {
      this.$axios.get("/admin/brand/getBrandListNoPage").then((res) => {
        this.supList = res.data;
      });
    },
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.storeGoodsId);

      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    lookinfo(e) {
      this.$axios
        .post("/admin/commodity/getCommodityDetail", {
          id: e.id,
        })
        .then((res) => {
          this.smvisible = true;
          this.shopinfo = res.data;
        });
    },
    getod() {
      this.searchForm = {
        name: "",
        storeGoodsType: "",
        brandId: "",
        classifyFirstId: "",
        classifyId: "",
      };
      this.classifyId = [];
      this.getStoreGoods(1);
    },
    sort(id) {
      this.sortVisible = true;
      this.$nextTick(() => {
        this.$refs.sort.init(id);
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    handleSizeChange(val) {
      this.size = val;
      this.getStoreGoods();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getStoreGoods();
    },
    addUpdateParameterButton(model) {
      this.getParametervisible = true;
      this.$nextTick(() => {
        this.$refs.getParameter.init(
          model.storeGoodsCartonsId,
          model.storeGoodsId
        );
      });
    },
    //获取园区列表
    // getGardenList(name) {
    // 	this.$axios.post("/admin/singleStoreGoods/getGardenList", {
    // 		name: ''
    // 	}).then(res => {
    // 		this.GardenIdList = res.data;
    // 	})
    // },
    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getStoreGoods(current) {
      if (this.classifyId.length > 0) {
        this.searchForm.classifyFirstId = this.classifyId[0];
        if (this.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (this.classifyId[1] == itrs.id) {
                this.searchForm.classifyId = itrs.uid;
              }
            });
          });
        } else {
          this.searchForm.classifyId = "";
        }
      } else {
        this.searchForm.classifyId = "";
        this.searchForm.classifyFirstId = "";
      }
      if (current) {
        this.current = current;
      }

      this.loading = true;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
          this.loading = false;
        });
    },

    // 根据id删除数据
    removeById(id) {},

    delHandle(id) {
      this.$confirm("此操作将删除该商品，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/storeGoods/delStoreGoods", {
            storeGoodsId: id,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      });
    },

    addUpdateGoodsButton(model, d, f) {
      if (model != null) {
        this.dialog = true;

        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init(model.id, d, f);
        });
      } else {
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init();
        });
      }
      console.log(model);
    },

    //下架、上架商城商品
    updStoreGoodsIsOnframe(model) {
      var that = this;
      that
        .$confirm("操作需谨慎：此操作是将该商品下架，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .post("/admin/commodity/lowerCommodity", {
              id: model.id,
            })
            .then((res) => {
              that.getStoreGoods();
              that.$message({
                showClose: true,
                message: res.msg,
                type: "success",
                onClose: () => {},
              });
            });
        });
    },
    //设置是否轮播
    updStoreGoodsIsRotation(id) {
      this.$axios
        .post("/admin/singleStoreGoods/updSingleStoreGoodsIsRotation", {
          storeGoodsId: id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
            onClose: () => {
              this.getStoreGoods();
            },
          });
        });
    },
    balancePayment(id) {
      this.balancePaymentVisble = true;
      this.$nextTick(() => {
        this.$refs.balancePayment.init(id);
      });
    },
    //设置推荐商城商品
    updStoreGoodsIsRecommend(model) {
      this.$confirm(
        "是否" +
          (model.isRecommend == 1 ? "取消推荐" : "推荐商品") +
          "该商品？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios
          .post("/sysCommodityManagement/setProductRecommendations", {
            id: model.storeGoodsId,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    updStoreGoodsStatus(id) {
      this.updStoreGoodsStatusvisible = true;
      this.$nextTick(() => {
        this.$refs.updStoreGoodsStatus.init(id);
      });
    },
    nonQueuing(id) {
      console.log("id", id);
      this.nonQueuingVisible = true;
      this.$nextTick(() => {
        this.$refs.nonQueuing.init(id);
      });
    },
    viewInventory(id) {
      this.boxItemsVisible = true;
      this.$nextTick(() => {
        this.$refs.boxItems.init(id);
      });
    },
    boxRuleButton(id) {
      this.boxRuleVisible = true;
      this.$nextTick(() => {
        this.$refs.boxRule.init(id);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  font-size: 10px;
  margin-right: 10px;
  margin-top: 5px;
}

.titcon {
  width: 150px;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.stimg {
  width: 50px;
  height: 50px;
  border-radius: 6rpx;
  display: inline-block;
  margin-right: 10rpx;
}

.mb8 {
  margin-bottom: 10px;
}
.cont >>> img {
  width: 100%;
}
</style>
